import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import "dayjs/locale/es"; 

dayjs.extend(customParseFormat);
dayjs.locale("es");

const useAvailableDates = (fi, t, c) => {
  const dispatch = useDispatch();
  const [dates, setDates] = useState([]);
  const [loading, setLoading] = useState(false);


  useEffect(() => {

    const fetchDates = async () => {
      setLoading(true);
      if (t === "e" || t === "m") {
        if (fi) {
          const string = dayjs(fi,"YYYY-MM-DD").format("MMMM YYYY");
          const label = string.charAt(0).toUpperCase() + string.slice(1);
          setDates([{ value: fi, label }]);
         
        } else {
          const now = new Date();
          const currentYear = now.getFullYear();
          const currentMonth = now.getMonth() + 1;
          const cierreAgosto = new Date(currentYear, 8, 8);
          const nextYear = currentYear + 1;

          let availableDates;
          if (currentMonth < 5) {
            availableDates = [
              { value: `${currentYear}-04-01`, label: `Abril ${currentYear}` },
              { value: `${currentYear}-08-01`, label: `Agosto ${currentYear}` },
            ];
          } else if (now < cierreAgosto) {
            availableDates = [
              { value: `${currentYear}-08-01`, label: `Agosto ${currentYear}` },
              { value: `${nextYear}-04-01`, label: `Abril ${nextYear}` },
            ];
          } else {
            availableDates = [
              { value: `${nextYear}-04-01`, label: `Abril ${nextYear}` },
              { value: `${nextYear}-08-01`, label: `Agosto ${nextYear}` },
            ];
          }
          setDates(availableDates);
        }
      } else {
        const now = new Date();
        const currentYear = now.getFullYear();
        const currentMonth = now.getMonth() + 1;
        const cierreAgosto = new Date(currentYear, 8, 8);
        const nextYear = currentYear + 1;

        let availableDates;
        if (currentMonth < 5) {
          availableDates = [
            { value: `${currentYear}-04-01`, label: `Abril ${currentYear}` },
            { value: `${currentYear}-08-01`, label: `Agosto ${currentYear}` },
          ];
        } else if (now < cierreAgosto) {
          availableDates = [
            { value: `${currentYear}-08-01`, label: `Agosto ${currentYear}` },
            { value: `${nextYear}-04-01`, label: `Abril ${nextYear}` },
          ];
        } else {
          availableDates = [
            { value: `${nextYear}-04-01`, label: `Abril ${nextYear}` },
            { value: `${nextYear}-08-01`, label: `Agosto ${nextYear}` },
          ];
        }
        setDates(availableDates);
      }

      setLoading(false);
    };

    fetchDates();
  }, [fi, t, dispatch]);

  return { dates, loading };
};

export default useAvailableDates;